import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import * as auth from "@/js/http/auth.js";
import axios from "axios";
import ToolBar from "./UploaderToolbar.vue";
import Items from "./UploaderItems.vue";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
export default {
  props: {
    preloadedFiles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideUploadButton: {
      type: Boolean,
      default: false
    },
    canClear: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: Array,
      default: []
    },
    url: {
      type: String,
      default: "/"
    },
    multiple: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: null
    },
    idInput: {
      type: String,
      default: "file-upload"
    },
    required: {
      type: Boolean,
      default: false
    },
    additionalFormData: {
      type: Object,
      default: null
    },
    additionalHint: {
      type: String,
      default: null
    }
  },
  computed: {
    filteredFileTypes: function filteredFileTypes() {
      var _this2 = this;
      var filter = function filter(e) {
        return _this2.fileTypes.some(function (f) {
          return f.includes(e.extension);
        });
      };
      return this.fileTypesMap.filter(filter);
    },
    fileTypesMap: function fileTypesMap() {
      return [{
        extension: "xlsx",
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }, {
        extension: "xls",
        type: "application/vnd.ms-excel"
      }, {
        extension: "xlsm",
        type: "application/vnd.ms-excel.sheet.macroEnabled.12"
      }, {
        extension: "gif",
        type: "image/gif"
      }, {
        extension: "pdf",
        type: "application/pdf"
      }, {
        extension: "png",
        type: "image/png"
      }, {
        extension: "jpg",
        type: "image/jpeg"
      }];
    },
    hasAnyFile: function hasAnyFile() {
      var _this$files;
      return ((_this$files = this.files) === null || _this$files === void 0 ? void 0 : _this$files.length) > 0;
    }
  },
  data: function data() {
    return {
      idUploadContainer: "idUploadContainer",
      warningTriggered: false,
      temporaryFiles: Array.isArray(this.preloadedFiles) ? _toConsumableArray(this.preloadedFiles) : [],
      request: new FormData(),
      files: [],
      uploading: false,
      manageSingleFile: true,
      cancellationToken: null
    };
  },
  components: {
    "tool-bar": ToolBar,
    items: Items
  },
  methods: {
    deleteFile: function deleteFile() {
      this.$emit("sync", this.files);
    },
    cancelUpload: function cancelUpload() {
      var _this$cancellationTok;
      (_this$cancellationTok = this.cancellationToken) === null || _this$cancellationTok === void 0 || _this$cancellationTok.cancel();
      this.uploading = false;
    },
    resetFiles: function resetFiles() {
      this.files = [];
      this.temporaryFiles = [];
      this.request.delete("files");
      if (this.additionalFormData) {
        for (var key in this.additionalFormData) {
          if (Object.hasOwnProperty.call(this.additionalFormData, key)) {
            this.request.delete(key);
          }
        }
      }
      this.$emit("sync", this.files);
    },
    isSingleFile: function isSingleFile() {
      return !this.multiple && this.files.length > 0;
    },
    getUploaderFiles: function getUploaderFiles() {
      return this.files;
    },
    uploadAll: function uploadAll() {
      var _this3 = this;
      var preventResetFilesWhenFail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.uploading || this.files.length == 0 || this.files.every(function (thing) {
        return thing === null;
      })) return;
      this.uploading = true;
      this.files.forEach(function (cur, index) {
        if (cur == null) return;
        _this3.request.append("files", cur);
        _this3.temporaryFiles[index].status = "uploading";
      });
      if (this.additionalFormData) {
        for (var key in this.additionalFormData) {
          if (Object.hasOwnProperty.call(this.additionalFormData, key)) {
            var value = this.additionalFormData[key];
            if (value === null) {
              this.request.append(key, null);
            } else if (typeof value === "string" || typeof value === "number") {
              this.request.append(key, value);
            } else {
              this.request.append(key, JSON.stringify(value));
            }
          }
        }
      }
      this.createCancelToken();
      var config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: auth.getAuthHeaderFromToken(auth.getAccessToken())
        },
        cancelToken: this.cancellationToken.token
      };
      var _this = this;
      return axios.post(_this.url, _this.request, config).then(function (response) {
        _this.temporaryFiles = [];
        _this.files = [];
        if (!_this.isAllUploading()) _this.uploading = false;
        _this.request.delete("files");
        if (_this.additionalFormData) {
          for (var _key in _this.additionalFormData) {
            if (Object.hasOwnProperty.call(_this.additionalFormData, _key)) {
              _this.request.delete(_key);
            }
          }
        }
        _this.$emit("click:upload", response);
      }).catch(function (e) {
        if (!preventResetFilesWhenFail) {
          _this.temporaryFiles = [];
          _this.files = [];
        }
        _this.uploading = false;
        if (!axios.isCancel(e)) {
          var errorData = getErrorData(e, _this.managedExceptions, "Unable to upload", true);
          handleErrorData(_this, errorData);
        }
        _this.$emit("upload:failed");
        _this.request.delete("files");
        if (_this.additionalFormData) {
          for (var _key2 in _this.additionalFormData) {
            if (Object.hasOwnProperty.call(_this.additionalFormData, _key2)) {
              _this.request.delete(_key2);
            }
          }
        }
      });
    },
    dragover: function dragover(e) {
      e.stopPropagation();
      document.getElementById(this.idUploadContainer).classList.add("drag-active");
      e.dataTransfer.dropEffect = "copy";
    },
    drop: function drop(e) {
      e.stopPropagation();
      document.getElementById(this.idUploadContainer).classList.remove("drag-active");
      this.createFile(e);
    },
    dragleave: function dragleave() {
      document.getElementById(this.idUploadContainer).classList.remove("drag-active");
    },
    createCancelToken: function createCancelToken() {
      var _this$cancellationTok2;
      (_this$cancellationTok2 = this.cancellationToken) === null || _this$cancellationTok2 === void 0 || _this$cancellationTok2.cancel();
      this.cancellationToken = axios.CancelToken.source();
    },
    clickOnInput: function clickOnInput() {
      var uploadInput = document.getElementById(this.idInput);
      uploadInput.click();
    },
    clickedInput: function clickedInput(e) {
      this.createFile(e);
      e.target.value = "";
    },
    createUrl: function createUrl(cur) {
      var temp = {
        id: Date.now() + Math.random(),
        type: cur.type.match(/image.*/) ? "image" : "file",
        name: cur.name,
        url: URL.createObjectURL(cur),
        status: "pending",
        percent: 0
      };
      this.temporaryFiles.push(temp);
      return temp;
    },
    createFile: function createFile(e) {
      var _this4 = this,
        _this$files2;
      var files = _toConsumableArray(e.target.files || e.dataTransfer.files);
      if (files.some(function (x) {
        return _this4.filteredFileTypes.every(function (a) {
          return a.type !== x.type;
        });
      })) {
        this.warningTriggered = true;
        var _this = this;
        setTimeout(function () {
          _this.warningTriggered = false;
        }, 3000);
        return;
      }
      files.forEach(function (x) {
        return x.temp = _this4.createUrl(x);
      });
      (_this$files2 = this.files).push.apply(_this$files2, _toConsumableArray(files));
      this.$emit("sync", this.files);
      if (this.required) {
        this.$emit("uploaderContainsFile", true);
      }
    },
    isAllUploading: function isAllUploading() {
      var uploading = false;
      var uploadingList = [];
      this.temporaryFiles.forEach(function (cur) {
        return uploadingList.push(cur.status);
      });
      if (uploadingList.includes("uploading")) return true;
      return uploading;
    }
  },
  mounted: function mounted() {
    if (this.id) this.request.append("id", this.id);
  }
};